import {SymbolApiDto} from "./restModels";

export class Symbol {
	constructor(public readonly id: string, public readonly filename: string) {}

	public static fromJson(json: SymbolApiDto): Symbol {
		return new Symbol(json.id, json.filename);
	}
}
